<template>
  <div class="front-stat_fst" :class="{ [curTheme]: true }">
    <div class="fst_heading">
      <div class="fst_ctr">Показатели активности платформы</div>
    </div>
    <div class="fst_cells fst_ctr">
      <div
        v-for="(el, i) in stat"
        v-if="stat"
        class="fst_cell"
        :key="`cell-${i}`">
        <img class="fst_cell-icon" :src="`/static/grx/icons/stat/${el.Name}.png`">
        <div class="fst_cell-value">{{ spacedNumber(el.Value) }}</div>
        <div class="fst_cell-title" v-html="el.Title"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {

  data() {
    return {
      /*
      stat: [
        { title: 'Сделок', value: 97006, icon: 'handshake' },
        { title: 'Транзакций', value: 1235886, icon: 'reload' },
        { title: 'Отметок «мне нравится»', value: 263645, icon: 'heart' },
        { title: 'Зарегистри&shy;рованных пользователей', value: 2500, icon: 'user' },
        { title: 'Отзывов', value: 487, icon: 'bubble' },
        { title: 'Просмотров', value: 83588, icon: 'view' },
        { title: 'Объектов', value: 6645, icon: 'package' },
        { title: 'Вузов-участников', value: 487, icon: 'college' },
        { title: 'Блоков', value: 487, icon: 'hexagons' },
      ],
      */
      stat: null,
    };
  },

  created() {
    this.fetchStat();
  },

  methods: {

    fetchStat() {
      axios.get('statistics/platform').then((r) => {
        this.stat = r.data;
      }).catch(() => {});
    },

    spacedNumber(value) {
      const valStr = value.toString();
      let result = '';
      let spaceIndex = 1;
      for (let i = valStr.length - 1; i > -1; i -= 1) {
        result = `${valStr.charAt(i)}${result}`;
        if (spaceIndex % 3 === 0) {
          result = ` ${result}`;
        }
        spaceIndex += 1;
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
@import "../styles/common/main";

.front-stat_fst {
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  @media (max-width: 650px) {
    margin-bottom: 60px;
  }
  .fst_heading {
    font-size: 18px;
    margin-bottom: 60px;
    padding: 30px 15px;
    text-align: center;
    text-transform: uppercase;
    position: relative;
    z-index: 15;
    .fst_ctr {
      opacity: .7;
    }
    @extend .grad;
    @media (max-width: 650px) {
      margin-bottom: 35px;
    }
  }
  .fst_ctr {
    max-width: 1790px;
    padding: 0 20px;
    margin: 0 auto;
  }
  &:before {
    content: '';
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: .09;
    background: 100% 50% no-repeat url(/static/grx/hex-group.png);
    background-size: contain;
    box-shadow: none;
    @media (max-width: 850px) {
      display: none;
    }
  }
  .fst_cells {
    @extend .clearfix;
    position: relative;
    z-index: 2;
    .fst_cell {
      width: 33.333333%;
      float: left;
      padding: 0 30px 70px 125px;
      position: relative;
      &:nth-of-type(3n+1) {
        clear: left;
      }
      @media (max-width: 970px) {
        padding: 0 30px 70px 70px;
      }
      @media (max-width: 850px) {
        width: 50%;
        &:nth-of-type(3n+1) {
          clear: none;
        }
        &:nth-of-type(2n+1) {
          clear: left;
        }
      }
      @media (max-width: 650px) {
        padding: 0 10px 30px 0;
        text-align: center;
      }
      .fst_cell-value {
        font-size: 25px;
        font-weight: bold;
        @media (max-width: 650px) {
        }
      }
      .fst_cell-title {
        font-size: 17px;
        line-height: 20px;
        @media (max-width: 350px) {
          font-size: 15px;
          line-height: 18px;
        }
      }
      .fst_cell-icon {
        position: absolute;
        left: 50px;
        top: 0;
        width: 50px;
        height: auto;
        @media (max-width: 970px) {
          left: 0;
        }
        @media (max-width: 650px) {
          display: inline-block;
          margin-bottom: 15px;
          position: static;
        }
      }
    }
  }
  &.theme-b {
    &:before {
      opacity: .15;
    }
  }
  &.theme-w {
    .fst_heading {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FrontStat.vue